import { useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import { Modal } from '@mui/material';

function CentralityIndex() {
	const { centralityIndexOpen, setCentralityIndexOpen } =
		useContext(AppContext);

	return (
		<Modal
			open={centralityIndexOpen}
			onClose={() => setCentralityIndexOpen(false)}
		>
			{/* <!-- 기획의도 모달 팝업 --> */}
			<section className="CentralityIndexModalSection" tabIndex="-1">
				<div className="CentralityIndexModalPaper">
					<button
						className="CloseIconButton"
						onClick={() => setCentralityIndexOpen(false)}
					>
						<img src="img/popCloseBtn.png" alt="닫기" />
					</button>
					<div className="CentralityIndexModalPaperContent">
						<div className="HeadingBox">
							<h3 className="text-heading-lg">중심성 지수</h3>
						</div>
						<div className="Content">
							<h1 className="title">1. 유입 중심성 지수</h1>
							<div className="text-content">
								<li>
									개별 노드(격자)가 다른 노드로부터 목적통행 등의 흐름을{' '}
									<span>끌어들이면서</span> 미치는 영향력의 크기를 나타냄
								</li>
								<li>
									유입 중심성 지수가 상대적으로 높은 노드는 주변으로부터 다양한
									목적(예: 출근, 쇼핑, 여가·오락, 친교, 업무 등)의 통행을{' '}
									<span>끌어들임</span>으로써 주변 지역에{' '}
									<span>각종 서비스와 일자리를 제공하는 역할</span>을 할
									가능성이 큼
								</li>
								<p>
									→ 다시 말해, 유입 중심성 지수 값이 크면 '근무인구(즉 고용)이
									집적해 있을 가능성'이 큼
								</p>
								<li>
									임계치 이상의 값을 가지는 개별 격자를 추출하여, 해당 격자를
									'유입 중심성 거점'으로 간주할 수 있음
								</li>
							</div>
						</div>
						<div className="Content">
							<h1 className="title">2. 유출 중심성 지수</h1>
							<div className="text-content">
								<li>
									개별 노드(격자)에서 다른 노드로 목적통행 등의 흐름을{' '}
									<span>내보내면서</span> 미치는 영향력의 크기를 나타냄
								</li>
								<li>
									유출 중심성 지수가 상대적으로 높은 지역은 주변으로 다양한
									목적(예: 출근, 쇼핑, 여가·오락, 친교, 업무 등)의 통행을{' '}
									<span>내보냄</span>으로써 주변 지역에{' '}
									<span>노동력 등 생산요소를 제공하는 역할</span>을 할 가능성이
									큼
								</li>
								<p>
									→ 다시 말해, 유출 중심성 지수 값이 크면 '거주인구가 집적해
									있을 가능성'이 큼
								</p>
								<li>
									임계치 이상의 값을 가지는 개별 격자를 추출하여, 해당 격자를
									'유출 중심성 거점'으로 간주할 수 있음
								</li>
							</div>
						</div>
						<div className="Content">
							<h1 className="text-title">3. 중심성 지수 값의 해석</h1>
							<div className="text-content">
								<li>
									특정 노드(격자)가 <span>중심성 지수 값 1</span>을 가질 경우,
									체계 전체에서 총 노드 수에 관계없이 해당 노드가{' '}
									<span>중간수준의 중심성</span>을 갖는다고 해석할 수 있고,{' '}
									<span>
										중심성 지수가 1을 상회하면 도시체계 내에서 중심부의 위상
									</span>
									을 갖는 것으로 보며,
									<span> 중심성 지수가 1을 하회하면 주변부의 위상</span>을 갖는
									것으로 볼 수 있음
								</li>
							</div>
						</div>
						<br />
					</div>
				</div>
			</section>
		</Modal>
	);
}

export default CentralityIndex;
